export default "__VITE_ASSET__q5UbHkkX__"